import PromoMethods from 'src/pages/promotions/script/common.methods'

export default {
  name: 'promo-image-viewer',

  components: {},

  props: {
    imageURL: {
      type: String,
      default: ''
    }
  },

  methods: {
    ...PromoMethods
  }
}
